<span
    [class]="'iconify icon ' + classNames"
    [attr.data-icon]="icon"
    [style]="style"
></span>
